import { useSyncExternalStore } from 'react';
/**
 * Utility hook that returns true if the rendering is happening in the client as opposed to hydration or ssr rendering.
 */
export function useIsClientOnlyRendering() {
    const isClient = useSyncExternalStore(() => {
        return () => {
            // we don't change the value, so we don't provide subscription
        };
    }, () => true, // snapshot is true on the client side
    () => false // snapshot is false on server and during hydration
    );
    return isClient;
}
